import React from 'react';
import ReportPreviewGridLayout from './ReportPreviewGridLayout';
export default ({ report, date, timezone, width, datasets, cfjsons, importedWeatherWidgets, ...otherProps }) => {
    return (
        <ReportPreviewGridLayout
            layout={report.layout}
            widgetsConfiguration={report.widgetsConfiguration}
            importedWidgetblocks={report.importedWidgetblocks}
            date={date}
            timezone={timezone}
            width={width}
            datasets={datasets}
            cfjsons={cfjsons}
            importedWeatherWidgets={importedWeatherWidgets}
            report={report}
            {...otherProps}
        />
    );
};
